import { render, staticRenderFns } from "./GroupElement.vue?vue&type=template&id=2ab27e5e&scoped=true&"
import script from "./GroupElement.vue?vue&type=script&lang=js&"
export * from "./GroupElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab27e5e",
  null
  
)

export default component.exports